import { Translation } from "../../configMap";
import { OverviewType } from "../../app";

export enum FilterComponentType {
  INPUT = "INPUT",
  SELECT = "SELECT",
  API_SELECT = "API_SELECT",
  API_TREE_SELECT = "API_TREE_SELECT",
  DATE = "DATE",
}

// Deliberately `any`: an arbitrary JSON bag driven by per-customer backend
// configuration (column `metadata`, categorization `attribute`, modal state).
// Its keys and value types are not knowable here, and it is indexed into
// directly by ~10 call sites across metadata/, analytics/ and app/.
export interface KeyByAny {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export interface ColumnItem {
  key: string;
  generic: boolean;
  archiveOnly: boolean;
  translations: Translation | null;
  metadata: KeyByAny | null;
  defaultIndex: number;
}

export interface OverviewConfig {
  columnItems: Array<ColumnItem>;
}

export enum CustomCellType {
  TEXT,
  COPYABLE,
}

export interface OrderColumnItem {
  key: string;
  title: string;
  show: boolean;
}

export interface ChangeOverviewType {
  overviewType: OverviewType;
  hasUserInputs: boolean;
}
